/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";
import {GenericModelUtils} from "../../../Utils/GenericModelUtils";

export class RequiredValidator extends BaseValidator {
	constructor() {
		super();
	}

	name(model) {
		return "Is required"
	}

	logic(x, model, data) {
		const isNull = x == null;
		const isEmptyString = (typeof (x) === "string" && x.trim() === '');
		
		return !isNull && !isEmptyString;
	}

	message(model) {
		return "Required";
	}
}
